var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.389 2.12963L2.57109 5.27963C1.93359 5.80463 1.4165 6.92213 1.4165 7.76963V13.3271C1.4165 15.0671 2.75525 16.4921 4.39859 16.4921H12.6011C14.2444 16.4921 15.5832 15.0671 15.5832 13.3346V7.87463C15.5832 6.96713 15.0094 5.80463 14.3082 5.28713L9.93067 2.03963C8.939 1.30463 7.34525 1.34213 6.389 2.12963Z",
    stroke: "#B3B9C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.4922V11.2422",
    stroke: "#B3B9C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.a9d90a248458a4f4123ec27cd381b5fb.svg";
export { ForwardRef as ReactComponent };